"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// this file is needed to use jQuery's $.form.serializeObject() function used in billingform.jsx and upload.js

function jQSerializeObject() {
    return _jquery2.default.fn.serializeObject = function () {
        var a = void 0;
        var o = void 0;
        o = {};
        a = this.serializeArray();
        _jquery2.default.each(a, function () {
            if (o[this.name] !== undefined) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || "");
            } else {
                o[this.name] = this.value || "";
            }
        });
        return o;
    };
}
exports.default = jQSerializeObject();